import { combineReducers } from 'redux'
import { Reducer } from 'interfaces'
import { OnboardingAppState, OnboardingStatus } from 'interfaces/onboarding'
import { CLOSE_ONBOARDING } from 'actions/onboardingActions'
import { SET_MEMBER_INFO } from 'actions/memberActions'

const DEFAULT_STATUS_STATE = 'in_progress'

const statusReducer: Reducer<OnboardingStatus> = (state = DEFAULT_STATUS_STATE, action) => {
  switch (action.type) {
    case SET_MEMBER_INFO: {
      const { onboarding_step } = action.payload
      if (onboarding_step === 'finished' && state === 'in_progress') {
        return 'finished'
      }
      if (onboarding_step !== 'finished' && state !== 'in_progress') {
        return 'in_progress'
      }

      return state
    }

    case CLOSE_ONBOARDING:
      return 'closed'

    default:
      return state
  }
}

const onboardingAppReducer = combineReducers<OnboardingAppState>({
  status: statusReducer,
})

export default onboardingAppReducer
